import { API_BASE_URL } from './config';

export interface OsmPreprocessStatus {
  hasData: boolean;
  statistics: {
    nodes: number;
    roadSegments: number;
 addressPoints: number;
    administrativeBoundaries: number;
  };
  estimatedDatabaseSizeMB: {
    nodes: number;
    segments: number;
    addresses: number;
    boundaries: number;
  };
}

export interface OsmPreprocessResponse {
  success: boolean;
  message: string;
  filePath?: string;
  clearedExisting?: boolean;
}

export interface OsmClearResponse {
  success: boolean;
  message: string;
  deletedCounts: {
    nodes: number;
    roadSegments: number;
    addressPoints: number;
    administrativeBoundaries: number;
  };
}

export const osmPreprocessApi = {
  // Get preprocessing status
  getStatus: async (): Promise<OsmPreprocessStatus> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE_URL}/osmpreprocess/status`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch OSM preprocessing status');
    }

    return response.json();
  },

  // Start preprocessing
  preprocess: async (osmFilePath?: string, clearExisting: boolean = false): Promise<OsmPreprocessResponse> => {
    const token = localStorage.getItem('token');
    const params = new URLSearchParams();
    if (osmFilePath) params.append('osmFilePath', osmFilePath);
    params.append('clearExisting', clearExisting.toString());

  const response = await fetch(`${API_BASE_URL}/osmpreprocess/preprocess?${params}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const error = await response.json();
    throw new Error(error.message || 'Failed to start OSM preprocessing');
    }

    return response.json();
  },

  // Clear OSM data
  clear: async (): Promise<OsmClearResponse> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE_URL}/osmpreprocess/clear`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to clear OSM data');
    }

    return response.json();
  },

  // Download OSM data
  download: async (outputPath?: string): Promise<OsmPreprocessResponse> => {
    const token = localStorage.getItem('token');
    const params = new URLSearchParams();
    if (outputPath) params.append('outputPath', outputPath);

    const response = await fetch(`${API_BASE_URL}/osmpreprocess/download?${params}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const error = await response.json();
   throw new Error(error.message || 'Failed to download OSM data');
    }

    return response.json();
  },
};
